import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';
import RouteComponent from '../../components/RouteComponent';

export default class Page extends RouteComponent {
	render() {
		return (
			<DocumentTitle title="Technické prohlídky">
				<TabbablePage
					module="techtest"
					List={List}
					Form={Form}
					newTitle="Nová"
					listTitle="Seznam technických prohlídek"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Techtest/Page.js